import { memo, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "../../../shared/helpers/toast";
import { cdnLogin } from "../../conf";
const EntryPoint = withRouter(({ changeConfigChildRoute, error: { showError, status, key }, history, showGlobalError }) => {
    const { t } = useTranslation("notification");

    useEffect(() => {
        if (showError) {
            try {
                let statusNumber = {};
                if (status === null || status === undefined) return;
                if (typeof status === "object" && (status.hasOwnProperty("response") || status.hasOwnProperty("request"))) {
                    const { response, request } = status;
                    statusNumber = Number.isInteger(status) ? status : response ? response.status : request.status;
                } else {
                    statusNumber = status;
                }

                switch (statusNumber) {
                    case 200:
                    case 201:
                        if (key) {
                            toast(t(key), undefined, 'success');
                        }
                        showGlobalError({
                            showError: false,
                            status: null,
                            key: ""
                        })
                        break;
                    case 403:
                        localStorage.clear();
                        sessionStorage.clear();
                        changeConfigChildRoute();
                        toast(t("without_authorization"));
                        window.location.href = cdnLogin;
                        break;
                    case 401:
                        localStorage.clear();
                        sessionStorage.clear();
                        changeConfigChildRoute();
                        toast(t("without_authorization"));
                        window.location.href = cdnLogin;
                        break;
                    case 409:
                        if (key) {
                            toast(t(key));
                        } else {
                            toast(`${t("error_ocurred")}, ${t("try_again_later")}`);
                        }
                        break;
                    default:
                        if ( status && status.message && status.message.key) {
                            // Check if the message is already a full error message (not a translation key)
                            const message = status.message.key;
                            if (message.includes(' ') || message.length > 50) {
                                // It's a full error message, show it directly
                                toast(message);
                            } else {
                                // It's a translation key, translate it
                                toast(t(message));
                            }
                        } else {
                            toast(`${t("error_ocurred")}, ${t("try_again_later")}`);
                        }
                        break;
                }
            } catch (err) {
                console.error(err);
            }
        }
    }, [showError, status, key, history, changeConfigChildRoute, t]);

    return null;
});

export default memo(EntryPoint);
